package io.eqoty.shared.datalayer.functions

import io.eqoty.shared.datalayer.Repository
import io.eqoty.shared.datalayer.objects.AudioContainer
import io.eqoty.shared.datalayer.objects.StreamingFormatPreference

actual suspend fun Repository.getAudioStreamingFormatPreference(): StreamingFormatPreference {
    return StreamingFormatPreference(AudioContainer.OGG, StreamingFormatPreference.Quality.High)
}